module.exports = __webpack_public_path__ + "media/site_templates/www.localconcreters.com.au/images/splash-a4bc9552ad791608958f5073cbfb0bd2.jpeg";